/**
 * Product Mix Report API Service
 * @see Sprint - Rapport Product Mix
 */

import { apiClient } from '@/api/client';
import type { ProductMixReportData, ProductMixReportInput } from '@bstock/shared';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

/**
 * Get product mix report for a period
 */
export async function getProductMixReport(
  params: ProductMixReportInput
): Promise<ProductMixReportData> {
  const response = await apiClient.get<ApiResponse<ProductMixReportData>>(
    '/reports/product-mix',
    { params }
  );
  return response.data.data;
}
